import { booleanMap } from '../../../../shared/configs/searchParams';

export const roomByHasRelations = {
  extract: (room) =>
    room.relatedFlats?.length ? booleanMap.yes : booleanMap.no,
};

export const valueToContent = {
  [booleanMap.yes]: 'Есть связанность',
  [booleanMap.no]: 'Нет связаности',
};
